import React from 'react';
import API from 'utils/API';
import './style.scss';

const SiteFooter = () => {
    return (
        <footer className="site-footer">
            <div className="site-main">
                <div className="links">
                    <a href={API.PORTAL.host()} className="link">
                        Home
                    </a>
                    <a href="/disclaimers" className="link">
                        Disclaimers
                    </a>
                </div>
                <div className="services">
                    <p>Securities products and services offered to investors through TradeUP Securities, Inc.</p>
                    <p>
                        <a href="/disclaimers">Terms & Conditions</a>
                    </p>
                </div>
                <p className="copyright">&copy;2021TradeUP Securities, Inc. All rights reserved.</p>
                <a
                    href="https://brokercheck.finra.org/firm/summary/18483"
                    className="btn btn-footer-check"
                    target="_blank">
                    Broker Check
                </a>
            </div>
        </footer>
    );
};

export default SiteFooter;
